// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8m-3";
export var contentContainer = "_8m-0";
export var editorContainer = "_8m-1";
export var quillInputForm = "_8m-2";
export var zoneDivider = "_8m-4";